// src/components/ConfirmSignUp.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CognitoUser } from "amazon-cognito-identity-js";
import { useTheme } from "../theming";
import { userPool } from "../awsConfig";

const ConfirmSignUp = () => {
  const [code, setCode] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const username = localStorage.getItem("pendingUsername") || "";

  const handleConfirm = (e) => {
    e.preventDefault();
    if (!username) {
      setMessage("No pending username found. Please register again.");
      return;
    }

    setIsLoading(true);
    const cognitoUser = new CognitoUser({ Username: username, Pool: userPool });

    cognitoUser.confirmRegistration(code, true, (err, result) => {
      setIsLoading(false);
      if (err) {
        setMessage(`Confirmation failed: ${err.message}`);
        return;
      }
      setMessage("Email confirmed! You can now log in.");
      localStorage.removeItem("pendingUsername");
      setTimeout(() => navigate("/login"), 1500);
    });
  };

  const handleResend = () => {
    if (!username) return;
    const cognitoUser = new CognitoUser({ Username: username, Pool: userPool });
    cognitoUser.resendConfirmationCode((err) => {
      if (err) {
        setMessage(`Could not resend code: ${err.message}`);
        return;
      }
      setMessage("Confirmation code resent. Please check your email.");
    });
  };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-lg">
        <h2
          className="text-3xl font-serif font-semibold text-center"
          style={{ color: theme.accentColor }}
        >
          Confirm Your Email
        </h2>
        <p className="text-center text-sm" style={{ color: theme.textColor }}>
          We sent a confirmation code to the email address you registered with.
        </p>

        <form onSubmit={handleConfirm} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              Confirmation Code
            </label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
              style={{ borderColor: theme.secondaryColor }}
              placeholder="Enter your 6-digit code"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-2 px-4 font-semibold rounded-md disabled:opacity-50"
            style={{
              backgroundColor: theme.accentColor,
              color: theme.buttonTextColor,
            }}
          >
            {isLoading ? "Confirming…" : "Confirm Email"}
          </button>
        </form>

        {message && (
          <p className="text-sm text-center" style={{ color: theme.textColor }}>
            {message}
          </p>
        )}

        <div className="text-center">
          <button
            onClick={handleResend}
            className="text-sm underline"
            style={{ color: theme.accentColor }}
          >
            Resend confirmation code
          </button>
        </div>

        <div className="text-center">
          <button
            onClick={() => navigate("/login")}
            className="text-sm underline"
            style={{ color: theme.accentColor }}
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSignUp;
